import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';
import { useClientSideMenu } from './hooks';
import { convertEnabledMenus } from './logics';
import { ClientSideMenuPresentations } from './presentations';

export const ClientSideMenu: React.FC = () => {
  const {
    state: { imageUrl, email, clientName, featureFlags, isLoading },
    actions: { signOut },
  } = useClientSideMenu();

  const { enableStaging } = getEnvFeatureFlag();
  const enableMenus = convertEnabledMenus(featureFlags, isLoading, enableStaging);

  return (
    <ClientSideMenuPresentations
      imageUrl={imageUrl}
      displayName={email}
      clientName={clientName}
      signOut={signOut}
      enableMenus={enableMenus}
    />
  );
};
